var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React from "react";
import classNames from "classnames";
import { Row, Col } from "@riseart/antd-provider";
import { baseHeaderCls, baseHeaderRowCls, baseHeaderBorderCls, baseHeaderTransparentCls, baseHeaderColCls, baseHeaderColSingleCls, baseHeaderColLeftCls, baseHeaderColCenterCls, baseHeaderColRightCls } from "./Base.less";
var COLUMN_CLASSNAME_BY_IDX = [baseHeaderColLeftCls, baseHeaderColCenterCls, baseHeaderColRightCls];
var BaseHeader = /* @__PURE__ */ __name(function BaseHeader2(_ref) {
  var _ref$hasBorder = _ref.hasBorder, hasBorder = _ref$hasBorder === void 0 ? false : _ref$hasBorder, _ref$transparent = _ref.transparent, transparent = _ref$transparent === void 0 ? false : _ref$transparent, className = _ref.className, _ref$contentLeft = _ref.contentLeft, contentLeft = _ref$contentLeft === void 0 ? null : _ref$contentLeft, _ref$contentCenter = _ref.contentCenter, contentCenter = _ref$contentCenter === void 0 ? null : _ref$contentCenter, _ref$contentRight = _ref.contentRight, contentRight = _ref$contentRight === void 0 ? null : _ref$contentRight, _ref$columnsConfig = _ref.columnsConfig, columnsConfig = _ref$columnsConfig === void 0 ? [4, 14, 4] : _ref$columnsConfig;
  var columns = [contentLeft, contentCenter, contentRight];
  var validColumns = columns.filter(function(column) {
    return column;
  });
  return /* @__PURE__ */ React.createElement("header", {
    className: classNames(baseHeaderCls, _defineProperty(_defineProperty({}, baseHeaderBorderCls, hasBorder), baseHeaderTransparentCls, transparent), className)
  }, /* @__PURE__ */ React.createElement(Row, {
    type: "flex",
    align: "middle",
    justify: "space-between",
    className: baseHeaderRowCls
  }, validColumns && validColumns.length === 1 ? /* @__PURE__ */ React.createElement(Col, {
    className: classNames(baseHeaderColCls, baseHeaderColSingleCls)
  }, validColumns[0]) : columns.map(function(item, idx) {
    return item ? /* @__PURE__ */ React.createElement(Col, {
      span: columnsConfig && columnsConfig[idx],
      key: idx,
      className: classNames(baseHeaderColCls, COLUMN_CLASSNAME_BY_IDX[idx])
    }, item) : null;
  })));
}, "BaseHeader");
export {
  BaseHeader
};
